import * as React from 'react';
import { SearchStringContainer } from '../SearchStringContainer';

export const SearchStringBlockContainer: React.FC = () => {
  return <SearchStringContainer />;
};
